Vue.component('cardLibrary', {
  template: templates.cardLibrary,
  data() {
    return {
      model: {
        cards: {
          ultimate: [],
          ultra: [],
          legendary: [],
          normal: [],
          viewers: [],
          special_bone: [],
          ascension: [],
          exotic: [],
          variant: [],
          variant_user: [],
          delta: [],
          delta_cards: [],
          exotic_cards: [],
          favorites: [],
          legacy: []
        },
        page: {
          current: 1,
          max: 18,
          cards: [],
          count: 0
        },
        legacyPage: {
          current: 1,
          max: 18,
          cards: [],
          count: 0,
          total: 0,
          totalPages: 0,
          hasNext: false,
          hasPrev: false,
          isLoading: false
        },
        viewerCard: false,
        selected: false,
        activeTab: 'yours'
      }
    }
  },  
  beforeDestroy() {
    const c = this;
    
    c.$root.$off('selectCard');
    c.$root.$off('updateCards');
    c.$root.$off('updateViewersCard');
    c.$root.$off('boneCardAdded');
    c.$root.$off('confirmDump');
    c.$root.$off('confirmSpiritForge');
    c.$root.$off('confirmExaltedChamber');
    c.$root.$off('refreshDeltaCards');

    $('[data-view="viewer-dashboard"]').off('click', '[data-component="playing-card"]');
    $('[data-view="viewer-dashboard"]').off('click', '[data-component="special-card"]');
    $('[data-view="viewer-dashboard"]').off('click', '.view-card');
    
    $('.playing-card').removeClass('flipped fade_in');
    $('.view-card').removeClass('is-above is-visible');

    
    // Reset pagination if it exists
    if ($(".pagination").length) {
      try {
        $(".pagination").off(); // Remove pagination events if any
      } catch (e) {
        // Ignore errors if pagination cleanup fails
      }
    }
    
    $('.view-card > div').html('');
  },
  mounted() {
    const c = this;
    c.getAllCards();

    c.$root.$on(`selectCard`, data => {
      c.selectCardToggle(data.number, data.toggle);
    });

    c.$root.$on(`updateCards`, data => {
      c.getAllCards()
    });

    c.$root.$on(`updateViewersCard`, data => {
      c.getViewersCards('emmitted');
    });

    c.$root.$on('boneCardAdded', data => {
      c.getAllCards()
    })

    c.$root.$on('confirmDump', data => {
      c.upgradeTier(data)
    })

    c.$root.$on('confirmExaltedChamber', () => {
      c.getAllCards()
    })

    c.$root.$on('refreshDeltaCards', () => {
      // userService.getDeltaCards().then(function(response) {
      //   c.model.cards.delta_cards = response.data;
      // });
      c.getAllCards()
    })

    c.$root.$on('confirmSpiritForge', data => {
      c.removeCardFromSpiritForge(data)
    })

    c.$root.$on('loadLegacyCards', () => {
      c.getLegacyCards();
    });

    c.$root.$on('showCards', page => {
      c.model.activeTab = page;
      if (page === 'favorites' && !c.model.cards.favorites.length) {
        c.ViewerFavorites();
      }
      if (page === 'bone_cards' && !c.model.cards.special_bone.length) {
        c.viewBoneCards();
      }
      if (page === 'ascension_cards' && !c.model.cards.ascension.length) {
        c.viewAscension();
      }
      if (page === 'variant_cards' && !c.model.cards.variant.length) {
        c.getAllCards();
      }
      if (page === 'delta_cards' && !c.model.cards.delta_cards.length) {
        c.viewDeltaCards();
      }
      if (page === 'exotic_cards' && !c.model.cards.exotic_cards.length) {
        c.viewExoticCards();
      }
    });


    $('[data-view="viewer-dashboard"]').on('click', '[data-component="playing-card"]', function(e) {
   
      const $this = $(this);
      const isCover = $this.attr('id') === 'cover';
      
      if ($this.hasClass('hq-select')) {
        const number = $this.attr('data-number')
        c.$root.$emit('removedCard', {number: number});
        return;
      }

      if (isCover) {
        return;
      }

      if ($this.hasClass('dump-remove')) {
        const number = $this.attr('data-number')
        c.$root.$emit('removeDumpCard', {number: number});
        return;
      }

      if ($this.hasClass('chamber-select')) {
        const number = $this.attr('data-number')
        c.$root.$emit('removeChamberCard', {number: number});
        return;
      }

      if (!e.ctrlKey && utils.onHold == false) {
        c.showCard($this.find('.playing-card-front').clone());
      }
      
      
      
    });

    $('[data-view="viewer-dashboard"]').on('click', '[data-component="special-card"]', function(e) {
      const cardsLoaded = document.getElementById('cards_loaded');
      const $this = $(this);

      // if ($this.hasClass('chamber-select')) {
      //   const number = $this.attr('data-number')
      //   c.$root.$emit('removeAscensionCard', {number: number});
      //   return;
      // }

      if ($this.hasClass('hq-select')) {
        const number = $this.attr('data-number')
        c.$root.$emit('removedCard', {number: number});
        return;
      }

      if ($this.hasClass('dump-remove')) {
        const number = $this.attr('data-number')
        c.$root.$emit('removeDumpCard', {number: number});
        return;
      }

      if (!e.ctrlKey && utils.onHold == false) {

        c.showSpecialCard($this.find('.playing-card-front').clone());
      }
      
    });

    $('[data-view="viewer-dashboard"]').on('click', '.view-card', function(e) {
      if ($(e.target).closest('.equipped-indicator').length) return;
      c.hideCard();
    });

  },
  methods: {
    selectCardToggle(number, toggle) {
      const c = this;
      for (let card of c.model.cards.viewers) {
        if (card.cardNumber == number && !card.cooldown) {
          card.selected = toggle;
          return;
        }
      }
    },
    showSpecialCard($card) {
      let description = $card.find('.bottom > div:first-of-type').data('description');
      $('.view-card > div').append($card);
      $('.view-card').addClass('is-above').addClass('is-visible');
      $('.view-card .info').removeClass('is-visible');
      $('.view-card .bottom').removeClass('is-hidden');
    },
    showCard($card) {
      let ability = $card.find('.bottom > div:first-of-type').attr('title').replace('Ability: ', '');
      let description = $card.find('.bottom > div:first-of-type').data('description');
      $('.view-card > div').append($card).append(`<p class="description"><span>${ability}:</span> ${description}</p>`);
      $('.view-card').addClass('is-above').addClass('is-visible');
      $('.view-card .info').removeClass('is-visible');
      $('.view-card .bottom').removeClass('is-hidden');
      $('.hq-nav').removeClass('indexed');
      $('.stats-bar').removeClass('indexed');
    },
    hideCard() {
      $('.hq-nav').addClass('indexed');
      $('.stats-bar').addClass('indexed');
      $('.view-card').removeClass('is-visible');
      setTimeout(function() {
        $('.view-card').removeClass('is-above');
        $('.view-card > div').html('');
      }, 300);
    },
    getPage() {
      const c = this;
      const totalCards = c.model.cards.viewers.length;
      const start = ((c.model.page.current * c.model.page.max) - c.model.page.max);
      const end = start + c.model.page.max;

      c.model.page.count = Math.ceil(totalCards / c.model.page.max);
      c.model.page.cards = c.model.cards.viewers.slice(start, end);

      setTimeout(function() {
        $('.playing-card:not(.disabled)').addClass('flipped');
      }, 1000);

    },
    setPage(number) {
      const c = this;
      c.model.page.current = number;
      c.getPage();
    },
    previousPage() {
      const c = this;
      c.model.page.current--;
      c.getPage();
    },
    nextPage() {
      const c = this;
      c.model.page.current++;
      c.getPage();
    },
    getAllCards() {
      const c = this;
      cardService.getActive()
        .then(function (response) {
 

          for (let data of response.data) {
            data.image = data.isDeltaCard
              ? `${root}/images/delta-cards/${data.id}.png`
              : `${root}/images/cards/${data.id}.png`;
          }

          let cards = playingCards.groupCardsByTier(response.data);


          c.model.cards.ultimate = cards.ultimate.map(v => ({...v, count: 0}));
          c.model.cards.ultra = cards.ultra.map(v => ({...v, count: 0}));
          c.model.cards.legendary = cards.legendary.map(v => ({...v, count: 0}));
          c.model.cards.normal = cards.normal.map(v => ({...v, count: 0}));
          c.model.cards.variant = response.data.filter(card => card.variant).map(v => ({...v, count: 0}));
          c.model.cards.delta = response.data.filter(card => card.isDeltaCard).map(v => ({...v, name: '', count: 0, owned: false}));
          c.model.cards.exotic = response.data.filter(card => card.exotic).map(v => ({...v, count: 0}));
          c.getViewersCards('getCard');
          c.ViewerFavorites();
          c.viewBoneCards();
          c.viewAscension();
          c.viewDeltaCards();
          c.viewExoticCards();


        })
        .catch(function (error) {
          console.error('getAllCards error:', error);
        });
    },
    getViewersCards(condition) {
      const c = this;

      userService.unlockedCards()
        .then(function (response) {

          c.model.cards.viewers = c.getViewersCardsInfo(response.data).map(v => ({...v, selected: false}));

          c.setCardCount();
          c.viewVariantCards();

          if(condition === 'emmitted'){
              $('.playing-card:not(.disabled)').addClass('fade_in');
          }
          else{
            c.getPage();
            setTimeout(function() {
       
              $(".pagination").rPage();
              $('.playing-card:not(.disabled)').addClass('flipped');
            }, 1000);
          }
       

          // setTimeout(function() {
          //   c.getViewersCards('refreshed');
          // }, 60000);

        })
        .catch(function (error) {
          
        });
    },
    getViewersCardsInfo(cards) {
      const c = this;
      let viewersCards = [];
      const now = new Date();

      for (let card of cards) {
        // Skip consumed/inactive cards (spirit forged, ascension sacrificed)
        if (card.active === false) {
          continue;
        }

        // Exclude legacy (seasonal) cards from card library
        // Legacy cards are those with season_end_date in the past
        if (card.season_end_date) {
          const seasonEndDate = new Date(card.season_end_date);
          if (seasonEndDate < now) {
            // Skip this card - it's a legacy seasonal card
            continue;
          }
        }

        if (card.isEventCard) {
          card.image = `${root}/images/cards/${card.id}.png`;
          viewersCards.push(playingCards.getCardStats(card));
          continue;
        }

        let viewersCard = c.findCard(card.id);

        if (viewersCard != null) {
          card.image = `${root}/images/cards/${card.id}.png`;
          viewersCards.push(playingCards.getCardStats(card));
        }
      }

      console.log(viewersCards)

      return viewersCards;
    },
    setCardCount() {
      const c = this;
      c.checkCards(c.model.cards.ultimate);
      c.checkCards(c.model.cards.ultra);
      c.checkCards(c.model.cards.legendary);
      c.checkCards(c.model.cards.normal);
      c.checkCards(c.model.cards.exotic);
      c.checkCards(c.model.cards.variant);
    },
    checkCards(cards) {
      const c = this;
      for (let card of cards) {
        card = c.getGetStats(card);
        card.count = c.getUnlockQuantity(card);
      }
    },
    getUnlockQuantity(card) {
      const c = this;
      let count = 0;
      for (let viewerCard of c.model.cards.viewers) {
        if (card.id == viewerCard.id && card.tier == viewerCard.tier && viewerCard.active) {
          count++;
        }
      }
      return count;
    },
    findCard(id) {
      const c = this;
      const allTiers = [
        ...c.model.cards.normal,
        ...c.model.cards.ultimate,
        ...c.model.cards.ultra,
        ...c.model.cards.legendary,
        ...c.model.cards.exotic,
        ...c.model.cards.variant,
        ...c.model.cards.delta,
      ];
      return allTiers.find(card => card.id == id) || null;
    },
    getGetStats(card) {
      const c = this;
      for (let viewerCard of c.model.cards.viewers) {
        if (card.id == viewerCard.id && card.tier == viewerCard.tier) {
          card.name = viewerCard.name;
          card.description = viewerCard.description;
          card.accuracy = viewerCard.accuracy;
          card.attack = viewerCard.attack;
          card.defence = viewerCard.defence;
          card.hp = viewerCard.hp;
          card.speed = viewerCard.speed;
          card.ability = viewerCard.ability;
          card.type = viewerCard.type;

          if (viewerCard.cooldown) {
            card.cooldown = viewerCard.cooldown;
          }

          return card;
        }
      }
      return card;
    }
    ,
    ViewerFavorites(){
      const c = this;

      userService.getFavorites()
      .then(function (response) {

        c.model.cards.favorites = c.getViewersCardsInfo(response.data).map(v => ({...v, selected: false}));

        c.getPage();
        c.setCardCount();

        setTimeout(function() {
          $(".pagination").rPage();
          $('.playing-card:not(.disabled)').addClass('flipped');
      
        }, 1000);

      })
      .catch(function (error) {
        
      });
    },
    viewBoneCards(){
      const c = this;

      userService.getBoneCards()
      .then(function (response) {

        c.model.cards.special_bone = response.data;

        c.getPage();
        c.setCardCount();

        setTimeout(function() {
          $(".pagination").rPage();
          $('.playing-card:not(.disabled)').addClass('flipped');
      
        }, 1000);

      })
      .catch(function (error) {
        
      });
    },
    viewAscension(){
      const c = this;

      userService.getAscension()
      .then(function (response) {

        c.model.cards.ascension = response.data;

        c.getPage();
        c.setCardCount();

        setTimeout(function() {
          $(".pagination").rPage();
          $('.playing-card:not(.disabled)').addClass('flipped');

        }, 1000);

      })
      .catch(function (error) {

      });
    },
    viewDeltaCards(){
      const c = this;

      userService.getDeltaCards()
      .then(function (response) {


        for (let data of response.data) {
          data.image = `${root}/images/delta-cards/${data.cardId}.png`;
        }
        c.model.cards.delta_cards = response.data;

  
        for (const card of c.model.cards.delta) {
          const matches = response.data.filter(d => d.cardId === card.id);
          console.log(matches.length)
          if (matches.length) {
            card.name = matches[0].name;
            card.owned = true;
            card.count = matches.length;
          }
        }

        console.log(c.model.cards.delta)

        c.getPage();
        c.setCardCount();

        setTimeout(function() {
          $(".pagination").rPage();
        }, 1000);

      })
      .catch(function (error) {

      });
    },
    viewExoticCards(){
      const c = this;

      userService.getExoticCards()
      .then(function (response) {

        for (let data of response.data) {
          data.image = `${root}/images/cards/${data.cardId}.png`;
        }
        c.model.cards.exotic_cards = response.data;

        for (const card of c.model.cards.exotic) {
          const matches = response.data.filter(d => d.cardId === card.id);
          if (matches.length) {
            card.owned = true;
            card.count = matches.length;
          }
        }

        c.getPage();
        c.setCardCount();

        setTimeout(function() {
          $(".pagination").rPage();
        }, 1000);

      })
      .catch(function (error) {

      });
    },
    viewVariantCards() {
      const c = this;
      const variantIds = new Set(c.model.cards.variant.map(card => card.id));
      c.model.cards.variant_user = c.model.cards.viewers.filter(card => variantIds.has(card.id));
    },
    upgradeTier(data){
      const c = this;

      data.twitchId = utils.cookies.get('user_id');

      userService.upgradeTier(data)
      .then(function (response){
        c.getAllCards()
        setTimeout(function(){
          c.$root.$emit('tierUpdated');
        }, 3000)
      })
      .catch(function (error){

      })
    },
    removeCardFromSpiritForge(data){
      const c = this;

      data.type = "Inventory"
      data.active = false
      userService.spiritForge(data)
      .then(function (response){
        c.getAllCards()
        setTimeout(function(){
          c.$root.$emit('updateBark');
        }, 1000)
      })
      .catch(function (error){

      })
    },
    getLegacyCards(page = 1) {
      const c = this;
      c.model.legacyPage.isLoading = true;

      userService.getLegacyCards(page, c.model.legacyPage.max)
        .then(function (response) {
          // Extract pagination metadata
          const pagination = response.data.pagination;
          c.model.legacyPage.current = pagination.page;
          c.model.legacyPage.total = pagination.total;
          c.model.legacyPage.totalPages = pagination.totalPages;
          c.model.legacyPage.hasNext = pagination.hasNext;
          c.model.legacyPage.hasPrev = pagination.hasPrev;
          c.model.legacyPage.count = c.model.legacyPage.totalPages;

          // Process card data
          const legacyCards = response.data.cards.map(card => {
            card.image = `${root}/images/cards/${card.id}.png`;
            return playingCards.getCardStats(card);
          });

          c.model.cards.legacy = legacyCards.map(v => ({...v, selected: false}));
          c.model.legacyPage.cards = c.model.cards.legacy;
          c.model.legacyPage.isLoading = false;

          setTimeout(function() {
            $(".pagination").rPage();
            $('.playing-card:not(.disabled)').addClass('flipped');
            $('.special-card:not(.disabled)').addClass('flipped');
          }, 1000);
        })
        .catch(function (error) {
          c.model.legacyPage.isLoading = false;
          console.error('Error loading legacy cards:', error);
        });
    },
    setPageLegacy(pageNumber) {
      const c = this;
      if (pageNumber >= 1 && pageNumber <= c.model.legacyPage.totalPages) {
        c.getLegacyCards(pageNumber);
      }
    },
    nextPageLegacy() {
      const c = this;
      if (c.model.legacyPage.hasNext) {
        c.getLegacyCards(c.model.legacyPage.current + 1);
      }
    },
    previousPageLegacy() {
      const c = this;
      if (c.model.legacyPage.hasPrev) {
        c.getLegacyCards(c.model.legacyPage.current - 1);
      }
    }

  }
});